
    import { State,Action,namespace } from 'vuex-class'
    import { Component,Vue } from 'vue-property-decorator'
    import Aside from './components/aside.vue'
    import ComHeader from './components/Header.vue'
    const site = namespace('site') //getMailList
    @Component({
        components:{
            Aside,
            ComHeader
        }
    })
    export default class Index extends Vue{
        @State('baseInfo') baseInfo:any
        
    }
